<template>
  <div
    role="tablist"
    aria-label="Выбор региона"
    class="region-switcher"
  >
    <button
      v-for="region in regions"
      :key="region.id"
      type="button"
      role="tab"
      :aria-selected="activeRegion === region.id"
      :aria-label="`Выбрать регион: ${region.name}`"
      :class="buttonClass(region.id)"
      @click="$emit('change', region.id)"
    >
      {{ region.name }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'FooterRegionSwitcher',
  props: {
    regions: {
      type: Array,
      required: true
    },
    activeRegion: {
      type: String,
      required: true
    }
  },
  methods: {
    buttonClass(regionId) {
      return this.activeRegion === regionId
        ? 'region-switcher__tab region-switcher__tab--active'
        : 'region-switcher__tab'
    }
  }
}
</script>

<style scoped>
.region-switcher {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem 1rem;
  margin: var(--region-switcher-margin, 0);
}

.region-switcher__tab {
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.35;
  color: #64748b;
  text-align: left;
  cursor: pointer;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.region-switcher__tab:hover {
  color: #0f172a;
}

.region-switcher__tab--active {
  color: var(--primary-main, #dc2626);
  font-weight: 600;
}

@media (min-width: 768px) {
  .region-switcher__tab {
    font-size: 0.875rem;
  }
}
</style>
